import { builder, Builder } from "@builder.io/react";

import { useSiteProperties } from "@orlandohealth/build-kit";
//import "./components/banner";
import { registerBannerComponents } from "@orlandohealth/build-kit";



// Import component registrations
//import "./components/cta";
import { registerCTAComponents } from "@orlandohealth/build-kit";
import { registerFormComponents } from "@orlandohealth/build-kit";
import { registerLayoutComponents } from "@orlandohealth/build-kit";
import { registerLocationComponents } from "@orlandohealth/build-kit";

// Import deprecated components
import { registerNavigationComponents } from "@orlandohealth/build-kit";

// Import physician components
import { registerPhysicianComponents } from "@orlandohealth/build-kit";

// Import search components
import { registerSearchComponents } from "@orlandohealth/build-kit";

//import "./components/ui";
import { registerUIComponents } from "@orlandohealth/build-kit";
import "./deprecated-components";

// Import the editor settings
import "./editor";

// Initialize builder
builder.init(process.env.NEXT_PUBLIC_BUILDER_API_KEY as string);

// Register Article model
Builder.register("component", {
  name: "Article",
  inputs: [],
  noWrap: true,
  canHaveChildren: true,
});

// Register site properties context
Builder.register("context", {
  name: "siteProperties",
  default: null,
  onChange: () => useSiteProperties(),
});

registerBannerComponents();
registerCTAComponents();
registerFormComponents();
registerLayoutComponents();
registerLocationComponents();
registerNavigationComponents();
// Provider entries live in the corp Builder space; register the component for
// rendering only, no insert menu (editors don't author providers here).
registerPhysicianComponents(undefined, { insertMenu: false });
registerSearchComponents();
registerUIComponents();